
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[index]",
      function () {
        return require("private-next-pages/products/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[index]"])
      });
    }
  